import NewPasswordInternal from './NewPasswordInternal';
import { componentName } from './componentName';

customElements.define(componentName, NewPasswordInternal);
